import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { correctHeight, detectBody } from './app.helpers';
import { UsuarioService } from './servicios/usuario.service';
import { Usuario } from './models/Usuario';
import { MessagingService } from './servicios/messaging.service';


declare var jQuery:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  implements OnInit{
  currentUser: Usuario;

  constructor(private userService: UsuarioService, private msgService: MessagingService) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit() {
    this.msgService.getPermission();
    this.msgService.receiveMessage();
  }


  ngAfterViewInit() {
    // Run correctHeight function on load and resize window event
    jQuery(window).bind("load resize", function() {
      correctHeight();
      detectBody();
    });

    // Correct height of wrapper after metisMenu animation.
    jQuery('.metismenu a').click(() => {
      setTimeout(() => {
        correctHeight();
      }, 300)
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts